angular
  .module("admin.reports")
  .controller("MyCeReportCtrl", function ($http, config, ReportsResource) {
    this.page = 1;
    this.pageSize = 20;

    this.categories = [
      { key: "politica", label: "Política" },
      { key: "negocios-e-empresas", label: "Negócios e Empresas" },
      { key: "operacao", label: "Operação" },
      { key: "expansao", label: "Expansão" },
      { key: "mercado", label: "Mercado" },
      { key: "geracao", label: "Geração", isSegment: true },
      { key: "transmissao", label: "Transmissão", isSegment: true },
      { key: "distribuicao", label: "Distribuição", isSegment: true },
      { key: "comercializacao", label: "Comercialização", isSegment: true },
    ];

    this.loadReport = function () {
      $http({
        url: config.api + "/api/v1/reports/customers-with-channels",
        method: "GET",
        params: {
          page: this.page,
          limit: this.pageSize,
        },
      }).then((response) => {
        const data = response.data.data;
        this.totals = data.totals;

        this.categories.map((x) => {
          x.total = this.totals[x.key] || 0;
        });

        data.data.map((x) => {
          x.categories = {};
          if (x.channels && Array.isArray(x.channels)) {
            for (let c of x.channels) {
              x.categories[c] = true;
            }
          }
        });

        this.report = {
          results: data.data,
          totalResults: data.metadata.total,
          pageSize: data.metadata.limit,
        };

        this.buildCharts();
      });
    };

    this.buildCharts = function () {
      this.barChart = {
        chart: {
          type: "bar",
        },
        xAxis: {
          categories: this.categories.map((c) => c.label),
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
            },
          },
        },
        series: [
          {
            data: this.categories.map((c) => c.total),
            id: "users",
            name: "Usuários",
          },
        ],
        title: {
          text: "Classificação Geral",
        },
      };

      this.subjectsChart = {
        chart: {
          type: "pie",
        },
        series: [
          {
            data: this.categories
              .filter((c) => !c.isSegment)
              .map((c) => {
                return {
                  name: c.label,
                  y: c.total,
                };
              }),
            id: "users",
            name: "Usuários",
          },
        ],
        title: {
          text: "Classificação Por Assunto",
        },
        plotOptions: {
          pie: {
            showInLegend: false,
          },
        },
      };

      this.segmentsChart = {
        chart: {
          type: "pie",
        },
        series: [
          {
            data: this.categories
              .filter((c) => c.isSegment)
              .map((c) => {
                return {
                  name: c.label,
                  y: c.total,
                };
              }),
            id: "users",
            name: "Usuários",
          },
        ],
        title: {
          text: "Classificação Por Segmento",
        },
        plotOptions: {
          pie: {
            showInLegend: false,
          },
        },
      };
    };

    this.exportToExcel = function () {
      this.isExporting = true;
      $http({
        url: config.api + "/api/v1/reports/customers-with-channels/export",
        method: "GET",
        responseType: "arraybuffer",
      }).then(
        (res) => {
          const downloadFile = ({ blob, fileName }) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");

            a.href = url;
            a.download = fileName;

            a.dispatchEvent(
              new MouseEvent("click", {
                view: window,
                bubbles: true,
                cancelable: false,
              })
            );

            window.URL.revokeObjectURL(url);
          };

          this.isExporting = false;
          const blob = new Blob([res.data], {
            type: "text/csv;charset=utf-8;",
          });
          downloadFile({ blob: blob, fileName: "MeuCanalEnergia.csv" });
        },
        (error) => {
          console.error("[MyCeReportCtrl] Erro ao exportar:", error);
          this.isExporting = false;
        }
      );
    };

    this.loadReport();
  });
